import React, {Component} from "react"
import PropTypes from "prop-types"
import moment from "moment"
import classNames from "classnames"
import styles from "./SetMembership.scss"
import {_directCheckout, _getListPlans} from "../../../../../services/apis/PaymentServices"
import {SingleDatePicker} from "react-dates";

class SetMembership extends Component {
    state = {
        planId: '5b963e2bdbb463b366995b1a',
        finish: moment(),
        price: 0,
        focused: false,
        listPlans: [],
        result: null
    }

    componentDidMount() {
        this._getListPlans()
    }

    _getListPlans = async () => {
        try {
            const response = await _getListPlans()
            const {success, data} = response

            if (success) {
                this.setState({
                    listPlans: data
                })
            }
        } catch (error) {
            console.error(error)
        }
    }

    _handleChangePlan = (e) => {
        const {value} = e.target

        this.setState({
            planId: value
        })
    }

    _handleOnFocused = () => {
        this.setState({
            focused: !this.state.focused
        })

    }

    _handleOnChangeDate = (date) => {
        this.setState({
            finish: date
        })
    }

    _onChangePrice = (e) => {
        const {value} = e.target

        this.setState({
            price: value
        })
    }

    _onClickSubmit = (e) => {
        e.preventDefault()

        const {planId, finish, price} = this.state
        const {userId} = this.props

        _directCheckout({userId, price, planId, finish})
            .then((response) => {
                this.props.onChange()
            })
            .catch(error => {
                console.log(error)
            })
    }

    render() {
        const {price, finish, focused, planId, listPlans} = this.state

        return (
            <td>
                <div className={styles.wrapper}>

                    <div className={classNames(styles.item, "plan d-flex justify-content-between")}>
                        <label>Plan:</label>
                        <select className="form-control"
                                onChange={this._handleChangePlan} value={planId}>
                            {
                                listPlans.reverse().map(plan => {
                                    if (plan.public) {
                                        return <option key={plan._id} value={plan._id}>{plan.title}</option>
                                    }
                                    return null
                                })
                            }
                        </select>
                    </div>

                    <div className={classNames(styles.item, "finish-date d-flex justify-content-between")}>
                        <label>Finish Date:</label>

                        <SingleDatePicker date={finish} focused={focused} onFocusChange={this._handleOnFocused}
                                          onDateChange={this._handleOnChangeDate}/>
                    </div>

                    <div className={classNames(styles.item, "price d-flex justify-content-between")}>
                        <label>Price ($)</label>
                        <input min={0}
                               className="form-control"
                               onChange={this._onChangePrice}
                               value={price}
                               type="number"/>
                    </div>

                    <button onClick={this._onClickSubmit} className={classNames(styles.submit, "btn btn-primary")}>
                        Set Membership
                    </button>
                </div>
            </td>
        )
    }
}

SetMembership.propTypes = {
    userId: PropTypes.string,
    onChange: PropTypes.func
}

export default SetMembership


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/user/SetMembership/SetMembership.js